import styled from 'styled-components';
import {ModalPage} from '../ModalPage';
import {ReactNode} from 'react';
import {useModal} from '@hooks';

export const BigMapModal = ({title, main, footer}: {title: string; main: ReactNode; footer: ReactNode}) => {
  const {closeModal, modalPages, removePages} = useModal();
  const goBack = () => removePages(1);

  return (
    <StyledModalPage
      onClose={closeModal}
      onBack={modalPages.length > 1 ? goBack : undefined}
      title={title}>
      <div className="flex flex-col h-full">
        <div className="min-h-1 flex-grow">{main}</div>
        <footer>{footer}</footer>
      </div>
    </StyledModalPage>
  );
};

const StyledModalPage = styled(ModalPage)`
  --modal-padding-x: 0;
  --modal-padding-y: 0;
`;
